import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu as MenuIcon, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home", end: true, testId: "nav-home" },
  { to: "/menu", label: "Menù", testId: "nav-menu" },
  { to: "/contatti", label: "Contatti", testId: "nav-contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Measure navbar height and expose as CSS var so hero can compute 100vh - nav
  useEffect(() => {
    const nav = document.querySelector(".ps-navbar");
    if (!nav) return;
    const setVar = () => {
      const h = Math.round(nav.getBoundingClientRect().height);
      document.documentElement.style.setProperty("--nav-h", `${h}px`);
    };
    setVar();
    const ro = new ResizeObserver(setVar);
    ro.observe(nav);
    window.addEventListener("resize", setVar);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", setVar);
    };
  }, []);

  return (
    <header
      className={`ps-navbar ${scrolled ? "scrolled" : ""}`}
      data-testid="site-navbar"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between py-2 sm:py-2.5">
          <NavLink to="/" aria-label="Pizzeria Salviano — Home" data-testid="nav-logo-link" className="flex items-center">
            <Logo height={48} className="sm:hidden" />
            <Logo height={60} className="hidden sm:block xl:hidden" />
            <Logo height={68} className="hidden xl:block" />
          </NavLink>

          <nav
            className="hidden md:flex items-center gap-1 lg:gap-2"
            aria-label="Navigazione principale"
            data-testid="nav-desktop"
          >
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.testId}
                className={({ isActive }) => `ps-navlink ${isActive ? "active" : ""}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-[#f4ead8] hover:text-[#f5c518] transition-colors"
            aria-label={open ? "Chiudi menu" : "Apri menu"}
            aria-expanded={open}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={28} /> : <MenuIcon size={28} />}
          </button>
        </div>

        <div
          className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-300 ease-out ${
            open ? "max-h-72 opacity-100 pb-4" : "max-h-0 opacity-0"
          }`}
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col gap-1 pt-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                data-testid={`${l.testId}-mobile`}
                className={({ isActive }) =>
                  `ps-navlink justify-start w-full ${isActive ? "active" : ""}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};
